<template>
  <h3>Sequences</h3>
  <DataTable
    v-model:expanded-rows="expandedSequencesRows"
    :value="sequencesLocalData"
    :expanded-rows="expandedSequencesRows"
    data-key="sequence_id"
    @row-expand="onSequencesExpand"
  >
    <template #empty>
      No records found
    </template>
    <template #loading>
      Loading records, please wait...
    </template>
    <Column
      expander
      style="width: 5rem"
    />
    <Column
      field="title"
      header="Title"
    />
    <Column
      field="preferred_communication_method"
      header="Preferred Comms."
    >
      <template #body="slotProps">
        <span v-if="slotProps.data.preferred_communication_method">
          {{ slotProps.data.preferred_communication_method.replace(/_/g, ' ') }}
        </span>
      </template>
    </Column>
    <Column
      field="budget"
      header="Budget"
    >
      <template #body="slotProps">
        <span v-if="slotProps.data.budget">
          {{ $n(slotProps.data.budget, 'currency') }}
        </span>
      </template>
    </Column>
    <Column
      field="start_date"
      header="Start Date"
    >
      <template #body="slotProps">
        {{ $d(new Date(slotProps.data.start_date), 'short') }}
      </template>
    </Column>
    <Column
      field="end_date"
      header="End Date"
    >
      <template #body="slotProps">
        <span v-if="slotProps.data.end_date">
          {{ $d(new Date(slotProps.data.end_date), 'short') }}
        </span>
      </template>
    </Column>
    <Column
      field="active"
      header="Status"
    >
      <template #body="slotProps">
        <Tag
          :value="slotProps.data.active ? 'Active':'Inactive'"
          :severity="slotProps.data.active ? 'success':'danger'"
          style="margin: 5px;"
        />
      </template>
    </Column>
    <Column>
      <template #body="slotProps">
        <Button
          icon="pi pi-envelope"
          outlined
          rounded
          severity="info"
          @click="openMessageInfoModal(slotProps.data)"
        />
      </template>
    </Column>
    <Column
      field="last_message_sent"
      header="Last Message On"
    >
      <template #body="slotProps">
        <span v-if="slotProps.data.last_message_sent">
          {{ $d(new Date(slotProps.data.last_message_sent), 'short') }}
        </span>
      </template>
    </Column>
    <Column>
      <template #body="slotProps">
        <span class="key-container">
          <Button
            outlined
            rounded
            severity="info"
            :loading="loadingSequenceEdits"
            @click="openConfirmActivateDeactivateSequenceModal(slotProps.data)"
          >
            {{ slotProps.data.active ? 'Deactivate':'Activate' }} 
          </Button>
          <!-- <Button
                      icon="pi pi-pencil"
                      outlined
                      rounded
                      severity="info"
                      @click="openEditSequenceModal(slotProps.data)"
                    /> -->
          <Button
            icon="pi pi-trash"
            outlined
            rounded
            severity="danger"
            @click="openConfirmSequenceDeletion(slotProps.data)"
          />
        </span>
      </template>
    </Column>
    <template #expansion="slotProps">
      <div>
        <div class="flex-row item-data">
          <span class="detail-item-header">Description:</span>
          <span class="detail-item-value">{{ slotProps.data.description }}</span>
        </div>
        <div 
          v-if="slotProps.data.sequence_recommendation"
          class="flex-row item-data"
        >
          <span class="detail-item-header">Strong Pro Recommended:</span>
          <span class="detail-item-value">{{ slotProps.data.sequence_recommendation.title }}</span>
        </div>
        <div 
          class="flex-row item-data"
        >
          <span class="detail-item-header">Triggering Event:</span>
          <span class="detail-item-value">{{ slotProps.data.sequence_event.name }}</span>
        </div>
        <div class="flex-row item-data">
          <span class="detail-item-header">Marketing Consent: </span>
          <span class="detail-item-value">{{ slotProps.data.marketing_consent ? "Yes": "No" }}</span>
          <span class="detail-item-header">Health Outreach Consent: </span>
          <span class="detail-item-value">{{ slotProps.data.health_outreach_consent ? "Yes": "No" }}</span>
        </div>
        <DataTable
          :value="slotProps.data.follow_ups"
        >
          <template #empty>
            No records found
          </template>
          <template #loading>
            Loading records, please wait...
          </template>
          <Column
            field="follow_up_order"
            header="#"
          />
          <Column
            field="days_after"
            header="Days After"
          />
          <Column
            field="template.name"
            header="Template"
          />
          <Column
            field="template_body"
            header="Body"
          />
          <Column
            field="template_subject"
            header="Subject"
          />
        </DataTable>
        <div class="flex-row">
          <h3>Analytics Info</h3>
        </div>
        <DataTable
          :value="slotProps.data.sequence_stats"
          :loading="slotProps.data.loadingExpandedRow"
        >
          <template #empty>
            No records found
          </template>
          <template #loading>
            Loading records, please wait...
          </template>
          <Column
            field="cost"
            header="Sequence Cost"
          />
          <Column
            field="num_messaged"
            header="# Messaged"
          />
          <Column
            field="num_responded"
            header="# Responded"
          />
          <Column
            field="sms"
            header="# SMS"
          />
          <Column
            field="email"
            header="# Email"
          />
        </DataTable>
        <div class="flex-row">
          <h3>Enterprise Info</h3>
        </div>
        <DataTable
          :value="slotProps.data.message_info"
          :loading="slotProps.data.loadingExpandedRow"
        >
          <template #empty>
            No records found
          </template>
          <template #loading>
            Loading records, please wait...
          </template>
          <Column
            field="email_sent"
            header=" # Email Sent"
          />
          <Column
            field="sms_sent"
            header="# SMS Sent"
          />
          <Column
            field="email_delivered"
            header="# Email Delivered"
          />
          <Column
            field="sms_delivered"
            header="# SMS Delivered"
          />
          <Column
            field="email_scheduled"
            header="# Email Scheduled"
          />
          <Column
            field="sms_scheduled"
            header="# SMS Scheduled"
          />
          <Column
            field="cost"
            header="Cost"
          />
        </DataTable>
      </div>
    </template>
  </DataTable>
  <AdminMessagingInfoModal
    v-if="displayMessageInfoModal"
    :sequence-id="selectedSequence.sequence_id"
    :sequence-title="selectedSequence.title"
    @close-modal="displayMessageInfoModal = false"
  />
</template>

<script>
import AdminMessagingInfoModal from '@/components/modals/admin-messaging-info-modal.vue';
import axios from 'axios';
import { useConfirm } from 'primevue/useconfirm';

export default {
  name: 'SequenceLocationsTable',
  components: {
    AdminMessagingInfoModal,
  },
  props: {
    sequencesData: {
      type: Object,
      required: true
    },
    locationId: {
      type: String,
      required: true
    },
  },
  emits: [
    'refresh',
  ],
  data() {
    return {
      expandedSequencesRows: [],
      sequencesLocalData: [],
      loadingSequenceEdits: false,
      sequencesDataError: null,
      sequenceAddEditMode: null,
      selectedSequence: null,
      displayAddEditSequenceModal: false,
      confirmationDetails: {},
      confirm: useConfirm(),
      displayMessageInfoModal: false,

    }
  },
  mounted() {
    this.$store.dispatch('getRefreshToken');
    this.sequencesLocalData = structuredClone(this.sequencesData);
  },  
  methods: {
    async onSequencesExpand(event) {
      this.$store.dispatch('getRefreshToken');

      let sequence_id = event.data.sequence_id;
      event.data.loadingExpandedRow = true;
      try {
        let payload = {
          location_id: this.locationId
        }
        const res = await axios.post(`/api/sequence/admin/${sequence_id}/stats`, payload, this.$store.state.header);
        this.handleSequenceStatsSuccess(res, event);
      } catch (err) {
        this.handleSequenceStatsError(this.handleAxiosError(err, event));
      }
    },
    handleSequenceStatsSuccess(res, event) {
      console.log('The handle sequence stats response is: ', res.data);
      console.log('The handle sequence stats event is: ', event);

      event.data.sequence_stats = res.data.sequence_stats.sequence_stats;
      event.data.message_info[0] = res.data.message_info;
      event.data.loadingExpandedRow = false;
    },
    handleSequenceStatsError(err, event) {
      console.log('The sequence stats error is: ', err);
      event.data.loadingExpandedRow = false;
    },
    openAddSequenceModal() {
      this.$store.dispatch('getRefreshToken');
      this.sequenceAddEditMode = 'create';
      this.displayAddEditSequenceModal = true;
    },
    openEditSequenceModal(sequence) {
      this.$store.dispatch('getRefreshToken');
      this.sequenceAddEditMode = 'edit';
      this.selectedSequence = sequence;
      this.displayAddEditSequenceModal = true;
    },
    openConfirmSequenceDeletion(sequence) {
      this.$store.dispatch('getRefreshToken');
      this.selectedSequence = sequence;
      this.confirmationDetails = this.getSequenceConfirmationMessage(sequence, 'delete');
      this.confirm.require({
        header: 'Confirm Sequence Deletion',
        message: this.confirmationDetails.message,
        icon: 'pi pi-exclamation-triangle',
        group: 'settings_confirmation',
        /**
         * If the user confirms the deletion
         * Remove the sequence
         */
        accept: () => {
          this.deleteSequence(sequence);
        },
        reject: () => {
          console.log('The sequence deletion was cancelled');
        }
      })
    },
    deleteSequence(sequence) {
      this.$store.dispatch('getRefreshToken');
      this.loadingSequenceEdits = true;
      axios.post(`/api/sequence/admin/${sequence.sequence_id}/delete`, {},this.$store.state.header)
      .then(res => {
        this.handleDeleteSequenceSuccess(res);
      })
      .catch(err => {
        this.handleDeleteSequenceError(this.handleAxiosError(err));
      })
    },
    handleDeleteSequenceSuccess(res) {
      console.log('The delete sequence response is: ', res.data);
      this.loadingSequenceEdits = false;
      this.$emit('refresh');
    },
    handleDeleteSequenceError(err) {
      console.log('The delete sequence error is: ', err);
      this.sequencesDataError = err;
      this.loadingSequenceEdits = false;
    },
    getSequenceConfirmationMessage(sequence, action) {
      let message = '';
      if (action === 'delete') {
        message = `Are you sure you want to remove the sequence ${sequence.title}?`;
      }
      else if (action === 'activate') {
        message = `Are you sure you want to activate the sequence ${sequence.title}?`;
      }
      else if (action === 'deactivate') {
        message = `Are you sure you want to deactivate the sequence ${sequence.title}?`;
      }
      return {
        message: message
      }
    },
    openConfirmActivateDeactivateSequenceModal(sequence, action=null) {
      this.$store.dispatch('getRefreshToken');
      if (action == null) {
        action = sequence.active ? 'deactivate' : 'activate';
      }
      console.log('The action is: ', action);
      console.log('The sequence is: ', sequence);
      this.confirmationDetails = this.getSequenceConfirmationMessage(sequence, action);
      console.log('The confirmation details are: ', this.confirmationDetails); 
      this.confirm.require({
        header: 'Confirm Sequence Status',
        message: this.confirmationDetails.message,
        icon: 'pi pi-exclamation-triangle',
        group: 'settings_confirmation',
        /**
         * If the user confirms the change, activate/deactivate the sequence
         */
        accept: () => {
          let activeStatus = action === 'activate' ? true : false;
          this.activateDeactivateSequence(sequence, activeStatus);
        },
        reject: () => {
          console.log('The sequence removal was cancelled');
        }
      }) 
    },
    activateDeactivateSequence(sequence, active=null) {
      this.$store.dispatch('getRefreshToken');

      let followUps = [];
    
      sequence.follow_ups.forEach(followUp => {
        followUps.push({
          follow_up_id: followUp.follow_up_id,
          days_after: followUp.days_after,
          follow_up_order: followUp.follow_up_order,
          template_id: followUp.template.id,
          template_body: followUp.template_body,
          template_subject: followUp.template_subject,
        })
      });

      let payload = {
        location_id: this.locationId,
        title: sequence.title,
        description: sequence.description,
        preferred_communication_method: sequence.preferred_communication_method,
        sequence_event_id: sequence.sequence_event.event_id,
        active: active,
        start_date: sequence.start_date,
        end_date: sequence.end_date,
        marketing_consent: sequence.marketing_consent,
        health_outreach_consent: sequence.health_outreach_consent,
        sequence_recommendation_id: sequence.sequence_recommendation.sequence_recommendation_id,
        follow_ups: followUps,
      }

      this.loadingSequenceEdits = true;
      axios.post(`/api/sequence/admin/` + sequence.sequence_id + `/edit`, payload, this.$store.state.header)
      .then(res => {
        this.handleActivateDeactivateSequenceSuccess(res);
      })
      .catch(err => {
        this.handleActivateDeactivateSequenceError(this.handleAxiosError(err));
      })
    },
    handleActivateDeactivateSequenceSuccess(res) {
      console.log('The activate/deactivate sequence response is: ', res.data);
      this.loadingSequenceEdits = false;
      this.$emit('refresh');
    },
    handleActivateDeactivateSequenceError(err) {
      console.log('The activate/deactivate sequence error is: ', err);
      this.sequencesDataError = err;
      this.loadingSequenceEdits = false;
    },
    openMessageInfoModal(sequence) {
      this.$store.dispatch('getRefreshToken');
      this.selectedSequence = sequence;
      this.displayMessageInfoModal = true;
    },
  }
}
</script>